"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getAppConfig = _interopRequireDefault(require("../constants/getAppConfig"));
var _LiveAgent = _interopRequireDefault(require("../modules/LiveAgent"));
/* istanbul ignore file */

let liveAgent;
const getLiveAgentClient = _ref => {
  let {
    locale
  } = _ref;
  if (liveAgent) return liveAgent;
  liveAgent = new _LiveAgent.default();
  let liveAgentConfig;
  if (locale === 'zh') liveAgentConfig = (0, _getAppConfig.default)().liveAgent.zh;else liveAgentConfig = (0, _getAppConfig.default)().liveAgent.en;
  liveAgent.init((0, _getAppConfig.default)().liveAgent.scriptUrl, {
    liveAgentUrl: liveAgentConfig.chatUrl,
    chatId: liveAgentConfig.chatId,
    deploymentId: liveAgentConfig.deploymentId,
    orgId: liveAgentConfig.organisationId,
    isLoggedIn: true
  });
  return liveAgent;
};
var _default = exports.default = getLiveAgentClient;